import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useToggleable } from '@stores/toggleables';
import { LOGIN_DRAWER } from '@constants/toggleables';
import { mediaQuery } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import Logo from '@comp/Logo/Logo';
import useLoginModalExperiment from '@cont/Login/utils/hooks/useLoginModalExperiment';
import LoginComponent from '@cont/Login/LoginComponent';
import { useIsMobile } from '@stores/AppCommonData';
import { useState } from 'react';
import { getImage } from '@utils/imageHelper';
import MobileMenu from './MobileMenu';

const Header = styled.header`
  height: 72px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 3;
  background: var(--color-base-1);
  box-shadow: ${({ $hideHeaderShadow }) =>
    !$hideHeaderShadow ? boxShadowGenerator() : 'none'};
  ${mediaQuery.uptoMobile} {
    box-shadow: inset 0px -1px 0px var(--color-shadow);
    display: block;
    width: 100%;
    height: 48px;
  }
`;

const Nav = styled.nav`
  width: 1136px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  ${mediaQuery.uptoTablet} {
    width: 728px;
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: 0 16px;
  }
`;

const StyledLogo = styled(Logo)`
  @media (max-width: 47.95em) {
    grid-column: 1/2;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 24px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const NavLink = styled.a`
  color: var(--color-base-fill);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

const StyledHamburger = styled.img`
  width: 24px;
  height: 24px;
`;
const MobileMenuToggle = styled.div``;
function HeaderComponent({ className, showLogin, hideHeaderShadow }) {
  useLoginModalExperiment();
  const { isOpen: showLoginDrawer, closeElement: closeLoginDrawer } =
    useToggleable(LOGIN_DRAWER);
  const isMobile = useIsMobile();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const onClose = () => {
    closeLoginDrawer();
  };
  return (
    <>
      <Header className={className} $hideHeaderShadow={!!hideHeaderShadow}>
        <Nav>
          <StyledLogo />
          {!isMobile ? (
            <NavLinks>
              <NavLink href="#test-series">Schedule</NavLink>
              <NavLink href="#test-center">Test Centres</NavLink>
              <NavLink href="#test-series">Pricing</NavLink>
              <NavLink href="#faqs">FAQs</NavLink>
              <NavLink href="#help">Help</NavLink>
            </NavLinks>
          ) : (
            <MobileMenuToggle onClick={() => setIsMobileMenuOpen(true)}>
              <StyledHamburger
                src={getImage('testseries/hamburger.svg')}
                alt="menu"
              />
            </MobileMenuToggle>
          )}
          {isMobile && (
            <MobileMenu
              isOpen={isMobileMenuOpen}
              onClose={() => setIsMobileMenuOpen(false)}
            />
          )}
        </Nav>
      </Header>
      {showLogin && (
        <LoginComponent
          drawerProps={{ drawerState: showLoginDrawer, onClose, login: true }}
        />
      )}
    </>
  );
}

HeaderComponent.propTypes = {
  className: PropTypes.string,
  hideHeaderShadow: PropTypes.bool
};
HeaderComponent.defaultProps = {
  className: '',
  hideHeaderShadow: false
};

export default HeaderComponent;
